/*
 * Copyright (c) 2020. American Express Company
 */

import queryString from 'query-string';
import StorageService from './storage.service';

/**
 *  Some notes when setting up a new cobrand:
 *  1. Route 53: register the domain name as an alias to app.bodeswell.io
 *  2. CloudFront: add the domain name to Alternate Domain Names
 *  3. Google Console <https://console.developers.google.com/> Project OAuth / Credentials / BodesWell App
 *    add new URI to the list of URIs
 */
export const COBRANDS = ['mm', 'amex', 'principal', 'jh', 'metlife', 'minke', 'humpback', 'bwdemo'];

export default class CobrandService {
    public static setCobrandFromLocation(location: Location): string {
        let cobrand: string = CobrandService.parseCobrandFromLocation(location);
        if (!cobrand) {
            cobrand = process.env.REACT_APP_COBRAND;
        }
        cobrand && StorageService.setCobrand(cobrand);
        return cobrand;
    }

    public static getCobrand(): string {
        // only for testing, remove cobrand if '?cobrand=none'
        const params: any = queryString.parse(window.location.search);
        const overrideCobrand = params.cobrand;
        if (overrideCobrand === 'none') {
            StorageService.setCobrand(undefined);
            return undefined;
        }

        const cobrand = StorageService.getCobrand();
        if (cobrand) return cobrand;
        return CobrandService.setCobrandFromLocation(window.location);
    }

    private static parseCobrandFromLocation(location: Location): string {
        let cobrand: string;

        // cobrand hostname looks like COBRAND.mydomain.io, first word is the cobrand
        cobrand = location.hostname.split('.')[0];
        if (COBRANDS.includes(cobrand)) {
            return cobrand;
        }
        const params: any = queryString.parse(location.search);
        cobrand = params.cobrand;
        if (COBRANDS.includes(cobrand)) {
            return cobrand;
        }
        return undefined;
    }
}
